import React from "react";
import { ITop10Article } from "../../../types/Top10Article";
import { Button, Image, Popover, Tag, Typography } from "antd";
import { CLOUD_URL } from "../../../lib/env";
import { Link } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";
const { Text } = Typography;

type Props = {
  id: string;
  categoryId: string;
  page: number;
  pageSize: number;
  top10Articles: ITop10Article[];
};

const Top10ArticlesCategoriesPopOver = (props: Props) => {
  const { id, page, pageSize, top10Articles, categoryId } = props;
  const content = (
    <div className="space-y-1 max-w-xs">
      {top10Articles.map((item) => (
        <Text key={item.id}>{item.MainInfo.Title.En}</Text>
      ))}
    </div>
  );
  return (
    <Popover
      key={JSON.stringify(top10Articles)}
      title={
        <div className="flex flex-row w-full justify-between border-b pb-0.5">
          <span>Top 10 Websites</span>
          <Link
            to={`/main-websites/manage-categories/${id}/edit-top-10-articles/${categoryId}?page=${
              page + 1
            }&pageSize=${pageSize}`}
          >
            <Button size="small" type="link" icon={<EditOutlined />} />
          </Link>
        </div>
      }
      content={content}
      trigger="hover"
      placement="right"
    >
      <Tag color="blue" className="cursor-pointer p-2">
        <div className="flex flex-col gap-1">
          <span>Top 10 Articles</span>
        </div>
      </Tag>
    </Popover>
  );
};

export default Top10ArticlesCategoriesPopOver;
